export default __webpack_public_path__ + "static/media/4.07a7c92c.jpg";